import { useEffect, useRef } from "react";
import Lenis from "lenis";
import "@/App.css";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Fusion from "@/components/site/Fusion";
import Disciplines from "@/components/site/Disciplines";
import Contact from "@/components/site/Contact";
import Intro from "@/components/site/Intro";
import CookieConsent from "@/components/site/CookieConsent";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.25,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;

    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (selector) => {
    const el = document.querySelector(selector);
    if (el && lenisRef.current) lenisRef.current.scrollTo(el, { offset: -10 });
  };

  return (
    <div className="App grain relative bg-[#FBF9F5] text-[#121110]">
      <Intro />
      <Header onNav={scrollTo} />
      <main>
        <Hero onNav={scrollTo} />
        <Marquee />
        <Manifesto />
        <Fusion />
        <Disciplines />
        <Contact />
      </main>
      <CookieConsent />
    </div>
  );
}

export default App;
